const buyModuleCertificate = {
    init: function () {
        this.initAddCertificateToCart();
        this.initPriceBtn();
        this.initArbitraryCostCertificateBtn();
        this.chooseCertificateDenomination();
    },

    initArbitraryCostCertificateBtn: function () {
        $(document).on('click', '.arbitrary-cost-certificate label', function (e) {
            e.preventDefault();
            e.stopPropagation();

            if (!app.isUserAuthorized()) {
                app.openAuthModal();

                return
            }

            const $label = $(this);
            const $checkbox = $label.find('input[type="checkbox"]');
            const arbitraryCostCertificateInput = $label.closest('.wrapper-card-shop-content').find('.arbitrary-cost-certificate-input');
            const wrapperCardShopContent = $label.closest('.wrapper-card-shop-content')

            $label.closest('.wrapper-card-shop-content').find('.checkbox-group-wrapper').find('label').not($label).removeClass('active').removeClass('checked-label').find('input[type="checkbox"]').prop('checked', false);

            $label.addClass('active').addClass('checked-label');
            $checkbox.prop('checked', true);
            arbitraryCostCertificateInput.removeClass('hidden');
            wrapperCardShopContent.find('.addCartItemCertificate').removeClass('btn-disabled').addClass('btn-primary');
        })
    },

    initPriceBtn: function () {
        $(document).on('click', '.btn-checkbox-certificate-price, .arbitrary-cost-certificate label', function (e) {
            e.preventDefault();
            e.stopPropagation();

            const $label = $(this);
            const $checkbox = $label.find('input[type="checkbox"]');
            const certificateDataId = $checkbox.val();
            const certificateId = $checkbox.data('cetificateid');
            const certificatePrice = $checkbox.data('price');
            const wrapperCardShopContent = $label.closest('.wrapper-card-shop-content');
            const arbitraryCostCertificate = wrapperCardShopContent.find('.arbitrary-cost-certificate');

            const $priceTarget = wrapperCardShopContent.find('.add-to-cart-certificate-price');
            const currencySymbol = ($priceTarget.data('currency-symbol') || '').toString();
            const hasDiscountAttr = $checkbox.data('discount');
            const hasDiscount = hasDiscountAttr === 1 || hasDiscountAttr === '1' || hasDiscountAttr === true;
            if (certificatePrice && hasDiscount) {
                $priceTarget.text(`за\u00A0${certificatePrice}\u00A0${currencySymbol}`.trim());
            } else {
                $priceTarget.text('');
            }

            if (!$checkbox.is(':checked')) {
                $label.closest('.checkbox-group-wrapper').find('label').not($label).removeClass('active').removeClass('checked-label').find('input[type="checkbox"]').prop('checked', false);
                wrapperCardShopContent.find('.addCartItemCertificate').removeClass('btn-disabled').addClass('btn-primary');

                if (arbitraryCostCertificate.length) {
                    arbitraryCostCertificate.find('label').removeClass('active').removeClass('checked-label').find('input[type="checkbox"]').prop('checked', false);
                    wrapperCardShopContent.find('.arbitrary-cost-certificate-input').addClass('hidden');
                }

                $label.addClass('active').addClass('checked-label');
                $checkbox.prop('checked', true);

                if (app.isUserAuthorized()) {
                    $.ajax({
                        type: 'POST',
                        data: {
                            certificateDataId: certificateDataId,
                            certificateId: certificateId,
                        },
                        url: 'certificate-user/get-user-added-cart-certificate'
                    }).done((response) => {
                        let errorTextWrapper = wrapperCardShopContent.find('.error-certificate-text');

                        if (response.success === true) {
                            errorTextWrapper.hide();
                            wrapperCardShopContent.find('.count-cert').text(response.cartCertificatesCount);

                            if (response.cartCertificatesCount > 0) {
                                wrapperCardShopContent
                                    .find('.addToCartCertificateWrapper, .btn-counter-wrapper')
                                    .removeClass('hidden');
                                wrapperCardShopContent
                                    .find('.addToCartCertificateWrapper')
                                    .addClass('hidden');
                            } else {
                                wrapperCardShopContent
                                    .find('.addToCartCertificateWrapper')
                                    .removeClass('hidden');
                                wrapperCardShopContent
                                    .find('.btn-counter-wrapper')
                                    .addClass('hidden');
                            }
                        } else {
                            errorTextWrapper.text(response.message);
                            errorTextWrapper.show();
                        }
                    }).fail();
                }

            }
        });
    },

    initAddCertificateToCart: function () {
        $(document).on('click', '.plus-certificate, .minus-certificate, .addCartItemCertificate', function (event) {
            const $this = $(this);
            const actionUrl = $this.is('.minus-certificate')
                ? 'cart/delete-certificate'
                : 'cart/add-certificate';

            addCartItemCertificate($this, 1, actionUrl)
                .then(result => {
                    if (result === true) {
                        if ($this.hasClass('minus-certificate') && $this.closest('.certificate-btn-wrapper').find('.count-cert').text() === '0') {
                            $this.closest('.certificate-btn-wrapper')
                                .find('.addToCartCertificateWrapper, .btn-counter-wrapper')
                                .toggleClass('hidden');
                            $this.closest('.wrapper-card-shop-content')
                                .find('.certificateSum')
                                .removeClass('error-text');
                        } else if ($this.hasClass('addCartItemCertificate')) {
                            $this.closest('.addToCartCertificateWrapper')
                                .toggleClass('hidden');
                            $this.closest('.certificate-btn-wrapper')
                                .find('.btn-counter-wrapper')
                                .toggleClass('hidden');
                            $this.closest('.certificate-btn-wrapper')
                                .find('.certificateSum')
                                .addClass('hidden')
                            $this.closest('.wrapper-card-shop-content')
                                .find('.certificateSum')
                                .addClass('error-text');
                        }
                    }
                });
        });

        function addCartItemCertificate(thisBtn, count, ajaxUrl) {
            if (!app.isUserAuthorized()) {
                app.openAuthModal();
            } else {
                let certificateId = thisBtn.data('cetificateid');
                let certificateDataId = '';
                let arbitraryCostCertificateInputVal = '';

                const currentWrapperCardShopContent = thisBtn.closest('.wrapper-card-shop-content');
                const selectedValue = currentWrapperCardShopContent.find('.checkbox-group-wrapper').find('.active');
                const arbitraryCostCertificate = currentWrapperCardShopContent.find('.arbitrary-cost-certificate').find('.btn-checkbox-certificate-price');
                const arbitraryCostCertificateInput = currentWrapperCardShopContent.find('.arbitrary-cost-certificate-input')

                if (arbitraryCostCertificateInput.length > 0 && arbitraryCostCertificate.hasClass('active')) {
                    arbitraryCostCertificateInputVal = arbitraryCostCertificateInput.val();
                    certificateDataId = 0;

                    if (arbitraryCostCertificateInputVal === '' || arbitraryCostCertificateInputVal === 0) {
                        currentWrapperCardShopContent.find('.error-certificate-text').css('display', 'block').html('Введите сумму');

                        return Promise.resolve(false);
                    }
                } else {
                    if (selectedValue.length > 0) {
                        certificateDataId = selectedValue.find('input[type="checkbox"]').val();
                    }

                    if (certificateDataId === '' || certificateDataId === undefined) {
                        certificateDataId = currentWrapperCardShopContent.find('.certificateSum').data('certificatesum');
                    }

                    if (certificateDataId === '' || certificateDataId === undefined) {
                        currentWrapperCardShopContent.find('.error-certificate-text').css('display', 'block').html('Выберите сумму');

                        return Promise.resolve(false);
                    }
                }

                certificateDataId = parseInt(certificateDataId);

                return new Promise((resolve, reject) => {
                    $.ajax({
                        type: 'POST',
                        data: {
                            certificateId: certificateId,
                            certificateDataId: certificateDataId,
                            count: count,
                            arbitraryCertificateSum: arbitraryCostCertificateInputVal,
                        },
                        url: ajaxUrl
                    })
                        .done((response) => {
                            let errorTextWrapper = thisBtn.closest('.wrapper-card-shop-content').find('.error-certificate-text');

                            if (response.status === 'success') {
                                cartModule.updateHeaderCart(response.cart.count);
                                thisBtn.closest('.certificate-btn-wrapper').find('.count-cert').text(response.cart.countCertificates);
                                errorTextWrapper.hide();

                                resolve(true);
                            } else {
                                errorTextWrapper.text(response.message);
                                errorTextWrapper.show();

                                resolve(false);
                            }
                        })
                        .fail(reject);
                });
            }
        }
    },

    chooseCertificateDenomination: function () {
        $('.checkbox-group-wrapper').each(function () {
            const $wrapper = $(this);
            const $options = $wrapper.find('.btn-checkbox-certificate-price');
            if ($options.length >= 2) {
                $options.eq(1).trigger('click');
            }
        });
    }
};

$("document").ready(function () {
    buyModuleCertificate.init();
});